import { Config } from '@/types/Config';

export const config: Config = {
  isLocalHost: import.meta.env.VITE_IS_LOCAL_HOST === 'true',
  frontendUrl: import.meta.env.VITE_FRONTEND_URL!,
  backendUrl: import.meta.env.VITE_BACKEND_URL!,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN!,
  hotjarSiteId: Number(import.meta.env.VITE_HOTJAR_SITE_ID)!,
  hotjarVersion: 6,

  // formats
  dateFormat: 'dd/MM/yyyy',
  backendDateFormat: 'YYYY-MM-DD',
  backendTimeFormat: 'HH:mm:ss',

  // validations
  nameValidation: /^[A-Za-z0-9\s_-]+$/,
  passwordValidation: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
  fileNameValidation: /^[a-zA-Z0-9 _\-\.\,\(\)\[\]\{\}']+$/,

  // session configs
  sessionTimeout: Number(import.meta.env.VITE_SESSION_TIMEOUT) || 300,
  sessionDialogTime: Number(import.meta.env.VITE_SESSION_DIALOG_TIME) || 180,
};
